import { render } from "./DbSavedBlocksDrawer.vue?vue&type=template&id=1f13aa52"
import script from "./DbSavedBlocksDrawer.vue?vue&type=script&lang=js"
export * from "./DbSavedBlocksDrawer.vue?vue&type=script&lang=js"

import "./DbSavedBlocksDrawer.vue?vue&type=style&index=0&id=1f13aa52&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__